module.exports = __webpack_public_path__ + "img/status_approving_black-01.a814fd7c.png";